import { ComponentProps, forwardRef } from 'react';
import Dropdown from 'antd/es/dropdown';
import clsx from 'clsx';

interface OpDropdownProps extends ComponentProps<typeof Dropdown> {
  onClick?(): void;
  testId?: string;
}

/**
 * OpDropdown is a wrapper around Ant Design's Dropdown component.
 * It displays a menu overlay when users click or hover on an element.
 *
 * Use this component for contextual actions, navigation menus, or any scenario where you need to
 * present a list of options in a compact space. Often used with buttons or menu triggers.
 *
 * @example
 * <OpDropdown menu={{ items: menuItems }} trigger={['click']}>
 *   <Button>
 *     Actions <DownOutlined />
 *   </Button>
 * </OpDropdown>
 *
 */
export const OpDropdown = forwardRef<HTMLDivElement, OpDropdownProps>(
  (
    { children, className = '', testId = 'op-dropdown', ...dropdownProps },
    ref,
  ) => {
    return (
      <Dropdown data-testid={testId} {...dropdownProps}>
        <div ref={ref} className={clsx('op-dropdown', className)}>
          {children}
        </div>
      </Dropdown>
    );
  },
);
